import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'func',
  standalone: false,
})
export class FuncPipe implements PipeTransform {
  transform<T, K>(value: T, func: (v: T, ...args: any[]) => K, ...args: any[]): K {
    return func(value, ...args);
  }
}
